import * as React from "react";
import "./Footer.scss";
import { Grid, Container } from "@material-ui/core";
import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="footer">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item md={4} xs={12} className="item">
            <h2 className="first">empathiHR</h2>
            <p>
              Our Human Resources Compliance System has innovative features,
              advanced technology to dramatically reduce risk for your business
              so you can focus on what you do best – growing your business!
            </p>
          </Grid>
          <Grid item md={2} xs={12} className="item">
            <h2>Product</h2>
            <Link to="/forgot-password">Forgot Password</Link>
          </Grid>
          <Grid item md={2} xs={12} className="item">
            <h2>About</h2>
            <a href="https://empathihr.com/">Home</a>
          </Grid>
          <Grid item md={3} xs={12} className="item">
            <h2>Contact</h2>
            <a href="mailto:help@empathihr.com">help@empathihr.com</a>
          </Grid>
        </Grid>

        <div className="copyright">
          © {currentYear} empathiHR. All rights reserved.{" "}
          <a href="https://empathihr.com/terms-of-service/">Terms of Service</a>
        </div>
      </Container>
    </div>
  );
}
